import React, { useEffect, useState } from 'react';
import './index.scss';
import { hideLoading, showLoading } from "@/components/loading";
import { queryDefCode } from "@/api/projectManager_self";
import { Toast } from "antd-mobile";

const ActivityRules = ({ activityCode, onClose }) => {
  const [activityRules, setActivityRules] = useState(null);

  useEffect(() => {
    getActivityRules();
  }, []);

  const handleClick = () => {
    onClose && onClose();
  }

  const getActivityRules = async () => {
    try {
      showLoading();
      const res = await queryDefCode({codeType: 'activityRule', code: activityCode});
      hideLoading();
      if (res.code !== '000000') throw res.msg;
      const {data} = res;
      if (data.result && data.result.defCode) {
        const defCode = data.result.defCode;
        setActivityRules(defCode);
      }
    } catch (error) {
      hideLoading();
      Toast.show(error);
    }
  };

  return <div className='landape-recycling-rules'>
    <div className='rules-outer'>
      <div className="rules-title">{activityRules?.codeAlias}</div>
      <div className="rules-content">
        {activityRules?.otherSign}
      </div>
      <div className="rules-btn" onClick={handleClick}>我知道了</div>
    </div>
  </div>
}

export default ActivityRules;